export const DISPONIBILITA_SKLAD_TABLE_SCHEMA = 'DISPONIBILITA_SKLAD_TABLE_SCHEMA';
export const DISPONIBILITA_SKLAD_TABLE_DATA = 'DISPONIBILITA_SKLAD_TABLE_DATA';
export const DISPONIBILITA_ZAKAZKA_TABLE_SCHEMA = 'DISPONIBILITA_ZAKAZKA_TABLE_SCHEMA';
export const DISPONIBILITA_ZAKAZKA_TABLE_DATA = 'DISPONIBILITA_ZAKAZKA_TABLE_DATA';
export const ZMENA_PC = 'ZMENA_PC';

export const editMutations = <const>{
	ND_SKLAD_DODAVATEL_SELECT_MAPPER: 'ND_SKLAD_DODAVATEL_SELECT_MAPPER',
	ND_SKLAD_ZBOZI_DRUH_SELECT_MAPPER: 'ND_SKLAD_ZBOZI_DRUH_SELECT_MAPPER',
	ND_SKLAD_MISTO_SELECT_MAPPER: 'ND_SKLAD_MISTO_SELECT_MAPPER',
	ND_SKLAD_RABAT_SK_SELECT_MAPPER: 'ND_SKLAD_RABAT_SK_SELECT_MAPPER',
	DISPONIBILITA_SKLAD_TABLE_SCHEMA_MUTATION: 'DISPONIBILITA_SKLAD_TABLE_SCHEMA_MUTATION',
	DISPONIBILITA_SKLAD_TABLE_DATA_MUTATION: 'DISPONIBILITA_SKLAD_TABLE_DATA_MUTATION',
	DISPONIBILITA_ZAKAZKA_TABLE_SCHEMA_MUTATION: 'DISPONIBILITA_ZAKAZKA_TABLE_SCHEMA_MUTATION',
	DISPONIBILITA_ZAKAZKA_TABLE_DATA_MUTATION: 'DISPONIBILITA_ZAKAZKA_TABLE_DATA_MUTATION',
	ZMENA_PC_MUTATION: 'ZMENA_PC_MUTATION',
	ND_SKLAD_CREATE_KONTROLA_ND_MAPPER: 'ND_SKLAD_CREATE_KONTROLA_ND_MAPPER',
	CUSTOMER_POJISTOVNA_FILTER_SELECT_MAPPER: 'CUSTOMER_POJISTOVNA_FILTER_SELECT_MAPPER',
	SUPERSEDED_PART_MAPPER: 'supersededPartMapper',
};

export const listMutations = <const>{
	ZBOZI_DRUH_LIST_MAPPER: 'ZBOZI_DRUH_LIST_MAPPER',
	DODAVATEL_LIST_MAPPER: 'DODAVATEL_LIST_MAPPER',
	RESET_OBRATKOVOST: 'RESET_OBRATKOVOST',
};

export const editActions = <const>{
	CHECK_IF_ND_EXISTS: 'checkIfNdExists',
	DISPONIBILITA_SKLAD_TABLE_SCHEMA: 'skladTableSchema',
	DISPONIBILITA_SKLAD_TABLE_DATA: 'skladTableData',
	DISPONIBILITA_ZAKAZKA_TABLE_SCHEMA: 'zakazkaTableSchema',
	DISPONIBILITA_ZAKAZKA_TABLE_DATA: 'zakazkaTableData',
	ZMENA_PC: 'ZMENA_PC',
	KOREKCE_STAVU: 'korekceStavu',
	SPAREPART: 'saveSparePartReminders',
	SUPERSEDED_PART_MAPPER: 'supersededPartMapper',
};
